import { useMemo } from "react";
import { useCreatedEvent, useDeletedEvent, useGameContext } from "../../../core/game/client/useGameContext";
import { playerRecordsView, WriteablePlayerRecords } from "../../../core/game/interfaces/PlayerRecords";
import { ReplicatedObject } from "../../../core/game/interfaces/ReplicatedObject";
;
;
export class WriteableContact3DPlayerRecords extends WriteablePlayerRecords {
    onGameOver(lastGameSummary) {
        let summaryToReturn = lastGameSummary;
        if (this.context.gameState.data.secretWord !== undefined) {
            summaryToReturn.details.secretWord = this.context.gameState.data.secretWord;
        }
        if (this.context.clue !== undefined) {
            this.context.clue.commitDelete();
        }
        this.context.gameState.commitData({
            numRevealedLetters: 1,
            currentAdjustment: 0,
            previousClues: [],
            guesses: [],
        }, {
            deleteKeys: ['secretWord']
        });
        return summaryToReturn;
    }
}
export const Contact3DPlayerRecords = new ReplicatedObject('Contact3DPlayerRecords', [{ required: 'players' }], WriteableContact3DPlayerRecords, (input, data) => 'players', (oldData, newData, playerAndGameId) => playerRecordsView(oldData, newData, playerAndGameId.playerId, (numPlayers) => numPlayers >= 3));
export function useContact3DPlayerRecords() {
    return useGameContext('players');
}
export function useContact3DPlayerRecordsCreatedEvent() {
    return useCreatedEvent('players');
}
export function useContact3DPlayerRecordsDeletedEvent() {
    return useDeletedEvent('players');
}
export function useContact3DPlayerList() {
    const playerRecord = useContact3DPlayerRecords();
    return useMemo(() => Object.values(playerRecord.record).sort((a, b) => a.index - b.index), [playerRecord]);
}
//# sourceMappingURL=Contact3DPlayerRecords.js.map